<template>
  <div>
    <el-row :gutter="5">
      <el-col :span="5">
        <el-card :body-style="cardBodyStyle">
          <el-button type="primary" size="small" plain @click="handleRefreshTree">刷新</el-button>
          <el-button v-if="userId=='1'" type="primary" size="small" plain @click="handleAddTop">新增顶层</el-button>
        </el-card>
        <el-card :body-style="cardBodyStyle">
          <el-tree :data="dataTree" :props="defaultProps" node-key="id" @node-click="handleNodeClick"
            class="tree-container" :expand-on-click-node="false" :default-expanded-keys="expandedKeys">

            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }} </span>
              <span>
                <el-button v-if="data.children.length<1" type="text" size="mini" @click="() => handleEdit(node, data)">
                  编辑
                </el-button>
                <el-button v-if="data.children.length<1" type="text" size="mini"
                  @click="() => handleDelete(node, data)">
                  删除
                </el-button>
              </span>
            </span>


          </el-tree>
        </el-card>
      </el-col>
      <el-col :span="13">
        <el-card :body-style="cardBodyStyle">
          <el-button type="primary" size="small" plain @click="handleAdd">新增</el-button>
        </el-card>
        <el-card :body-style="cardBodyStyle">
          <el-table :data="tableData" border @row-click="handleCurrentRowChange">

            <el-table-column prop="id" label="编号" width="50" v-if="isShow" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="deptCode" label="部门编码" width="110" show-overflow-tooltip header-align="center"
              align="center">
            </el-table-column>
            <el-table-column prop="deptName" label="部门名称" width="200" show-overflow-tooltip header-align="center"
              align="center">
            </el-table-column>
            <el-table-column prop="deptDesc" label="部门说明" show-overflow-tooltip header-align="center">
            </el-table-column>
            <el-table-column prop="fId" label="父id" width="77" align="center" v-if="isShow" show-overflow-tooltip>
            </el-table-column>
            <!--  <el-table-column label="操作" width="200px" align="center">
              <template slot-scope="scope">
                <el-button size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
                <el-button size="mini" plain type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card :body-style="cardBodyStyle">
          <el-button type="primary" size="small" plain @click="handleAddUserDept">添加</el-button>
          </el-form-item>
          </el-form>
        </el-card>
        <el-card :body-style="cardBodyStyle">
          <el-table :data="tableDataUserDept" border>
            <el-table-column prop="id" label="id" show-overflow-tooltip v-if="isShow">
            </el-table-column>
            <el-table-column prop="user.userName" sortable label="用户名" show-overflow-tooltip header-align="center"
              align="center">
            </el-table-column>
            <el-table-column prop="user.userDesc" sortable label="姓名" show-overflow-tooltip header-align="center"
              align="center">
            </el-table-column>
            <el-table-column label="操作" width="100px" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button size="mini" plain type="danger" @click="handleDeleteUserDept(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="dialogVisible" width="400px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="用户编码" v-if="isShow">
          <el-input v-model="form.id"></el-input>
        </el-form-item>
        <el-form-item label="上级部门">
          <el-input v-model="form.fId" disabled size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="部门编码">
          <el-input v-model="form.deptCode" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="部门名称">
          <el-input v-model="form.deptName" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="部门说明">
          <el-input v-model="form.deptDesc" size="small" style="width: 200px;" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="success" size="small" @click="handleSave">保存</el-button>
        <el-button type="danger" size="small" @click="handleCancelSave">取消</el-button>
      </span>


    </el-dialog>

    <el-dialog :close-on-click-modal="false" v-dialogDrag title="编辑信息" :visible.sync="dialogVisibleUser" width="800px">
      <el-input v-model="queryUserDesc" placeholder="请输入查询条件" style="width :300px;float: left;"></el-input>
      <el-button type="info" @click="searchUser">查询</el-button>

      <el-table :data="tableDataUser" border>
        <el-table-column prop="userName" label="用户名" width="150" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="userDesc" label="姓名" width="150" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleAddUser(scope.row)">加入</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination size="mini" @size-change="UserhandleSizeChange" @current-change="UserhandleCurrentChange"
        :current-page="UsercurrentPage" :page-sizes="UserpageSizes" :page-size="UserpageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="UsertotalRows">
      </el-pagination>
    </el-dialog>
  </div>
</template>
<script>
  import axios from '@/axios'
  import tools from '@/tools'
  export default {
    data() {
      return {
        userId: localStorage.getItem('userId'),
        cardBodyStyle: tools.style.card,
        expandedKeys: [],
        queryUserDesc: '',
        dataTree: [],
        defaultProps: {
          children: 'children',
          label: 'deptName'
        },
        tableData: [],
        tableDataUser: [],
        tableDataUserDept: [],
        // fid: '',
        // fName: '',
        selectedDept: {},
        dialogVisible: false,
        dialogVisibleUser: false,
        userDept: {
          id: '',
          user: {
            id: ''
          },
          dept: {
            id: ''
          }
        },

        form: {
          id: '',
          deptCode: '',
          deptName: '',
          deptDesc: ''
        },
        isShow: false,
        // loading: true,
        // loadingTree: true,
        UsercurrentPage: 1,
        UsertotalRows: 0,
        UserpageSizes: [10, 20, 30, 40],
        UserpageSize: 10,
        selectedDeptId: ''
      }
    },
    mounted() {
      this.getTableData()
      this.getDataTree()
    },
    methods: {
      handleRefreshTree() {
        this.getDataTree()
      },
      getDataTree() {
        var url = 'framework/SysDepartment/queryTree.do'
        var param = {}
        axios.get(url, param).then(response => {
          this.dataTree = response.data.data
          // console.log(JSON.stringify(this.dataTree))
          if (this.dataTree.length == 1) {
            for (var node of this.dataTree) {
              this.expandedKeys.push(node.id)
            }
          }
        });
      },
      handleNodeClick(data) {
        // this.fid = data.id
        // this.fName = data.text
        // this.selectedDeptId = data.id
        this.selectedDept = data
        this.getTableData()
        this.getTableDataUserDept()
      },
      getTableData() {
        //console.log("获取table数据getTableData")
        var url = 'framework/SysDepartment/queryByFid.do'
        var param = {
          fid: this.selectedDept.deptCode
        }
        axios.post(url, param).then(response => {
          this.tableData = response.data.data
        });
      },

      getTableDataUserDept() {
        var url = 'framework/SysUserDept/queryByDeptId.do'
        var param = {
          deptId: this.selectedDept.id //this.selectedDeptId
        }
        axios.get(url, param).then(response => {
          this.tableDataUserDept = response.data.data
        });
      },
      getTableDataUser() {
        var url = 'framework/SysUser/query.do'
        var param = {
          page: this.UsercurrentPage,
          rows: this.UserpageSize,
          userDesc: this.queryUserDesc
        }
        axios.get(url, param).then(response => {
          this.tableDataUser = response.data.data.list
          this.UsertotalRows = response.data.data.total
        });
      },
      handleAddUserDept() {
        if (this.selectedDeptId === '') {
          this.$message({
            type: 'error',
            message: '先选择部门！',
          });
        } else {
          this.dialogVisibleUser = true
        }
      },
      searchUser() {
        this.getTableDataUser()
      },
      handleCurrentRowChange(row) {
        console.log(row.id)
        this.selectedDeptId = row.id
        this.getTableDataUserDept()
      },

      UserhandleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.UserpageSize = val
        this.getTableDataUser()
      },

      UserhandleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.UsercurrentPage = val
        this.getTableDataUser()
      },
      handleDeleteUserDept(row) {
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var url = 'framework/SysUserDept/remove.do'
          var param = {
            id: row.id
          }
          axios.post(url, param).then(response => {
            if (response.data.code === 0) {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getTableDataUserDept()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败' + response.data.msg
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      search() {
        this.getTableData()
      },

      handleAddUser(row) {
        this.userDept.user.id = row.id
        this.userDept.dept.id = this.selectedDeptId
        var url = 'framework/SysUserDept/save.do'
        var param = {
          json: JSON.stringify(this.userDept)
        }
        axios.post(url, param).then(response => {
          if (response.data.code === 0) {
            this.$message({
              type: 'success',
              message: '修改成功!',
            });
            //this.getTableDataUser()
            this.getTableDataUserDept()
          } else {
            this.$message({
              type: 'error',
              message: '修改失败' + response.data.msg,
            });
          }
        });
      },

      handleAddTop() {
        this.dialogVisible = true
        this.form = {
          id: '',
          deptCode: '',
          deptName: '',
          deptDesc: '',
          fId: 'D'
        }

        var url = 'framework/SysDepartment/queryNewCode.do'
        var param = {
          fid: 'D'
        }
        axios.get(url, param).then(response => {
          this.form.deptCode = response.data.data.code
        });

      },

      handleAdd() {
        this.dialogVisible = true
        this.form = {
          id: '',
          deptCode: '',
          deptName: '',
          deptDesc: '',
          fId: this.selectedDept.deptCode
        }
        var url = 'framework/SysDepartment/queryNewCode.do'
        var param = {
          fid: this.selectedDept.deptCode
        }
        axios.get(url, param).then(response => {
          this.form.deptCode = response.data.data.code
        });

      },





      // 编辑按钮事件
      handleEdit(node, data) {
        this.dialogVisible = true
        this.form = data
      },
      //保存按钮事件
      handleSave(row) {
        var url = 'framework/SysDepartment/save.do'
        var param = {
          json: JSON.stringify(this.form)
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            this.getTableData()
            this.getDataTree()
            this.dialogVisible = false
          } else {
            this.$message({
              type: 'error',
              message: '操作失败!' + response.data.msg
            });
          }


        });
      },
      //保存取消按钮事件   关闭编辑对话框
      handleCancelSave(row) {
        this.dialogVisible = false
      },
      // 删除按钮事件
      handleDelete(id) {
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var userId = sessionStorage.getItem('userId');
          var url = 'framework/SysDepartment/remove.do'
          var param = {
            id: id,
            userId: userId
          }
          axios.post(url, param).then(response => {
            if (response.data.code == '0') {
              this.$message({
                type: 'success',
                message: '操作成功!',
              });
              this.getTableData()
              this.getDataTree()
              this.dialogVisible = false
            } else {
              this.$message({
                type: 'error',
                message: '操作失败!' + response.data.msg
              });
            }

          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
    }
  };
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/view/system/department.vue